/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claimed_NextInputs */

const en_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to continue`)
};

const ar_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انقر للمتابعة`)
};

const de_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Fortfahren antippen`)
};

const es_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsa para continuar`)
};

const fr_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez pour continuer`)
};

const it_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca per continuare`)
};

const ja_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タップして続ける`)
};

const ko_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속하려면 탭하세요`)
};

const pt_br_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para prosseguir`)
};

const ru_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите, чтобы продолжить`)
};

const th_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แตะเพื่อดำเนินการต่อ`)
};

const tr_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam etmek için dokun`)
};

const zh_cn_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按空白处继续`)
};

const zh_tw_claimed_next = /** @type {(inputs: Claimed_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按空白處繼續`)
};

/**
* | output |
* | --- |
* | "Tap to continue" |
*
* @param {Claimed_NextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const claimed_next = /** @type {((inputs?: Claimed_NextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claimed_NextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claimed_next(inputs)
	if (locale === "ar") return ar_claimed_next(inputs)
	if (locale === "de") return de_claimed_next(inputs)
	if (locale === "es") return es_claimed_next(inputs)
	if (locale === "fr") return fr_claimed_next(inputs)
	if (locale === "it") return it_claimed_next(inputs)
	if (locale === "ja") return ja_claimed_next(inputs)
	if (locale === "ko") return ko_claimed_next(inputs)
	if (locale === "pt_br") return pt_br_claimed_next(inputs)
	if (locale === "ru") return ru_claimed_next(inputs)
	if (locale === "th") return th_claimed_next(inputs)
	if (locale === "tr") return tr_claimed_next(inputs)
	if (locale === "zh_cn") return zh_cn_claimed_next(inputs)
	return zh_tw_claimed_next(inputs)
});